import { render } from "./videos-on-demand.vue?vue&type=template&id=5fadf0cf&scoped=true"
import script from "./videos-on-demand.vue?vue&type=script&lang=js"
export * from "./videos-on-demand.vue?vue&type=script&lang=js"

import "./videos-on-demand.vue?vue&type=style&index=0&id=5fadf0cf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fadf0cf"]])

export default __exports__